import React from 'react';
import { FaSort, FaSortUp, FaSortDown } from 'react-icons/fa';

const sortIcon = (active, dir) => {
  if (!active) return FaSort;
  if (dir === 'asc') return FaSortUp;
  return FaSortDown;
};

const SortableTh = ({ label, sortKey, sort, onSort, style }) => {
  const active = sort.key === sortKey;
  const Icon = sortIcon(active, sort.dir);
  return (
    <th
      className={`fd-th-sortable${active ? ' fd-th-sortable--active' : ''}`}
      style={style}
      onClick={() => onSort(sortKey)}
      title="Clique para ordenar"
    >
      {label}
      <Icon className="fd-th-sort-icon" />
    </th>
  );
};

export default SortableTh;
